<template>
	<div class="wrapper">
		<div class="div_input">
			<div class="div_name">请输入车牌号进行绑定</div>
			<plate-input ref="plateInput1"></plate-input>
			<div class="div_button" @click="handleConfirm">确认绑定</div>
		</div>
	</div>
</template>

<script>
	import { bindPlate } from "../../../api/coupon/bindPlate";
	import { validatePlate } from '@/utils/plateValidator'
	import plateInput from '../components/plateInput'
	import { mapGetters } from 'vuex'
	import base from "@/api/base";
	export default {
        data() {
            return {
                // 停车场Id
                parkinglotId: "",
                // 车牌号码
                plateNumber: "",
                // 金额
                amount: 0.0,
                // 停车场名字
                plateName: "",
                // 进出记录Id
                parkRecId: "",
                areaId: undefined,
				baseUrl: base.url + "/",
                comeFrom: undefined
            };
        },
		components: {
            plateInput
		},
		computed: {
			...mapGetters(['userOpenid'])
		},
        mounted() {
			this.comeFrom = this.$route.query.comeFrom;
			
        },
        watch: {
            listType: function (val, oldval) {
                this.setList();
            }
        },
        methods: {
            getPlateNumber(data) {
                console.log('传值',data);
                this.plateNumber = data
            },
            handleConfirm() {
			if (validatePlate(this.$refs.plateInput1.getPlateNumber()).valid) {
                    let form = {
                        openid:localStorage.getItem('userOpenId')||this.userOpenid ,
                        plateNumber: this.$refs.plateInput1.getPlateNumber()
                    };
                    bindPlate(form).then(res => {
                        if (res.code == 200) {
                            if (this.comeFrom === 'plateInfo') {
                                this.$router.push("plateInfo")
                            } else if (this.comeFrom === 'platePay') {
                                this.$router.push("platePay")
                            }else {
                                this.$router.push("plateInfo")
							}
                        }
                    })
				}else {
					this.$weui.alert('车牌号格式错误！')
				}
            },
        },
	};
</script>

<style lang="stylus" scoped>
	@import '~common/stylus/variable';
	@import '~common/stylus/mixin';

	.wrapper {
		position: relative;
		width: 100%;
		height: 100%;
		background: #f5f5f5;

		.div_input {
			background: #ffffff;
			margin-top: 12px;
			padding: 20px;

			.div_name {
				font-size: 16px;
				font-weight: bold;
				line-height: 20px;
				margin-bottom: 25px;
			}

			.div_explain {
				background-color: #fff;
				margin-top: 12px;
				padding: 20px 20px 50px 20px;

				.div_name {
					font-size: 16px;
					margin-bottom: 15px;
					line-height: 20px;
					font-weight: bold;
				}

				.div_text p {
					margin: 0px;
					font-size: 14px;
					line-height: 28px;
				}
			}
			.div_button {
				color: #ffffff;
				width: 100%;
				height: 45px;
				background: #06ae56;
				box-shadow: 0px 5px 5px 0px rgba(84, 149, 246, 0.25);
				border-radius: 5px;
				font-size: 16px;
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: center;
				letter-spacing: 3px;
				margin-top: 16px;
			}
		}
	}
</style>
